import { Dictionary } from "node_modules/vue-router/types/router";

export function parseConfirmationQuery(query: Dictionary<string | (string | null)[]>): string[] {
  const queryEntries = Object.entries(query);
  
  if (!queryEntries.length) {
    return ["", ""];
  }

  if (queryEntries.length === 2) {
    return [
      query.username as string, 
      query.confirmation_code as string,
    ];
  } 
  
  const [usernameEntry, ...codeEntries] = queryEntries;
  let code = codeEntries.reduce((code: string, entry: any, idx: number) => {
    const [key, value] = entry;

    if (idx === 0) {
      return code + value;
    }

    if (!!key) {
      code += `&${key}`;
    }

    if (value !== null && !Array.isArray(value)) {
      code += `=${value}`;
    }

    if (Array.isArray(value)) {
      code += '&'.repeat(value.length);
    }

    return code;
  }, "")
  
  if (code.length < 6) code += "&";
  
  return [
    query.username as string, 
    code,
  ];
}